export default __webpack_public_path__ + "static/media/youtube.d6eb981a.svg";